import { renderFragmentClient } from './renderFragmentClient';
renderFragmentClient();
